export function qurl(field: string, value?: string | number): string {
  if (value !== undefined && value !== null && value !== '') {
    return `/?q=${field}: ${value}`;
  }
  return `/?q=${field}`;
}
